// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  //-----------------Live site----------------------//
  // baseUrl: "https://www.abilitydiagnostics.com/abadmin/api/",
  // assetsUrl: "https://www.abilitydiagnostics.com/abadmin/"

  //-----------------beta-2.0 site----------------------//
  // baseUrl: "https://www.abilitydiagnostics.com/beta-2.0/abadmin/api/",
  // assetsUrl: "https://www.abilitydiagnostics.com/beta-2.0/abadmin/"

  //-----------------https://nmd.sisproj.com/ site----------------------//
  // baseUrl: "https://nmd.sisproj.com/abadmin/api/",
  // assetsUrl: "https://nmd.sisproj.com/abadmin/"

//-----------------http://www.nationalmoleculardiagnostics.com/beta/ site----------------------//
  //baseUrl: "https://nationalmoleculardiagnostics.com/beta/nmdadmin/api/",
  //assetsUrl: "https://nationalmoleculardiagnostics.com/beta/nmdadmin/"

//-----------------test version live ------------------------------//
baseUrl: "https://nmd.sleekdev.com/nmdadmin/api/",
assetsUrl: "https://nmd.sleekdev.com/nmdadmin/"
};
